<template>
  <NaviLink
    :label="''"
    :href="props.href"
    :is-active-validator="props.isActiveValidator"
    class="navi-link-feeds"
  >
    <img
      :src="currentUser.avatarUrl"
      class="navi-link-feeds-avatar"
      width="24"
      height="24"
    >
    {{ props.label }}
  </NaviLink>
</template>

<script setup>
import useUserStore from '@/modules/shared/store/useUserStore'

import NaviLink from './NaviLink.vue'

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  href: {
    type: String,
    required: true,
  },
  isActiveValidator: {
    type: Function,
    default: ({ currentPath, listPath }) => (currentPath === listPath),
  },
})

const { currentUser } = useUserStore()
</script>

<style scoped lang="scss">
.navi-link-feeds-avatar {
  border-radius: 3px;
  margin-right: 8px;
}
</style>
